import { render, staticRenderFns } from "./MonitoringSKP.vue?vue&type=template&id=4b66dd86&scoped=true&lang=html&"
import script from "./MonitoringSKP.vue?vue&type=script&lang=js&"
export * from "./MonitoringSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66dd86",
  null
  
)

export default component.exports